import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrganizationRelocationRequestDto } from '../interfaces/organization-relocation-request-dto';
import { OrganizationRelocationValidationDto } from '../interfaces/organization-relocation-validation-dto';
import { OrganizationRelocationStatusDto } from '../interfaces/organization-relocation-status-dto';
import { OrganizationRelocationStatus } from '../enums/organization-relocation-status-enum';
import { OrganizationRelocationDto } from '../interfaces/organization-relocation-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class OrganizationRelocationService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/organization-relocation';
    }

    validate(requestDto: OrganizationRelocationRequestDto): Observable<OrganizationRelocationValidationDto> {
        return this.http.post<OrganizationRelocationValidationDto>(`${this.baseUrl}/validate`, requestDto);
    }

    queueRelocation(targetEnterpriseId: number, organizationId: number): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/queue/${targetEnterpriseId}/${organizationId}`, {});
    }

    createRelocation(requestDto: OrganizationRelocationRequestDto): Observable<OrganizationRelocationDto> {
        return this.http.post<OrganizationRelocationDto>(`${this.baseUrl}/create`, requestDto);
    }

    getStatuses(sourceEnterpriseId: number, organizationIds: number[] = []): Observable<OrganizationRelocationStatusDto[]> {
        let params = new HttpParams();
        if (organizationIds.length > 0) {
            organizationIds.forEach(id => {
                params = params.append('organizationIds', id.toString());
            });
        }
        return this.http.get<OrganizationRelocationStatusDto[]>(`${this.baseUrl}/${sourceEnterpriseId}/status`, { params });
    }

    getAdminStatuses(sourceEnterpriseId: number | null = null, targetEnterpriseId: number | null = null): Observable<OrganizationRelocationStatusDto[]> {
        let params = new HttpParams();
        if (sourceEnterpriseId !== null) {
            params = params.append('sourceEnterpriseId', sourceEnterpriseId.toString());
        }
        if (targetEnterpriseId !== null) {
            params = params.append('targetEnterpriseId', targetEnterpriseId.toString());
        }
        return this.http.get<OrganizationRelocationStatusDto[]>(`${this.baseUrl}/admin/status`, { params });
    }

    updateStatus(sourceEnterpriseId: number | null = null,
        targetEnterpriseId: number | null = null,
        organizationId: number,
        status: OrganizationRelocationStatus): Observable<void> {
        const statusDto: OrganizationRelocationStatusDto = {
            organizationRelocationRequestDto: {
                sourceEnterpriseId: sourceEnterpriseId ?? null,
                targetEnterpriseId: targetEnterpriseId ?? null,
                organizationId: organizationId
            },
            status: status,
            dateCompleted: []
        };
        return this.http.post<void>(`${this.baseUrl}/update/status`, statusDto);
    }
}
